<template>
  <!--所属部门id  只有admin才可以选    v-show="isAdmin"-->
  <el-cascader
    clearable
    size="mini"
    @change="searchChange"
    style="width: 160px;"
    placeholder="请选择执法机构"
    :options="ArrayDept"
    v-model="curDept"
    :props="defaultParams"
    change-on-select
    filterable
    :show-all-levels="false"
    ref="refHandleCascader"
  >
  </el-cascader>
</template>

<script>
import { mapState } from "vuex";
import { forData } from "../../utils/deptRemoveNull";
import { judgeSysAdmin } from "../../utils/utils";
import { getDept } from "../../api/module/dept";

export default {
  name: "deptCascade",
  computed: {
    ...mapState(["logInfo", "localDept", "refreshDeptFlag"])
  },
  props: ["deptKey", "currentMenuId"],
  data() {
    return {
      ArrayDept: [],
      curDept: [],
      defaultParams: {
        // 部门prop
        children: "childDeptList",
        label: "deptName",
        value: "deptId",
        expandTrigger: "hover"
      },
      deflutKey: this.deptKey,
      defaultFg: this.defaultwhenNodata,
      isAdmin: false
    };
  },
  methods: {
    handlePanel() {
      if (this.$refs.refHandleCascader) {
        this.$refs.refHandleCascader.dropDownVisible = false; // 关闭cascader弹出
      }
    },
    // 2:获取当前登录用户能显示的部门
    getCurrentDept() {
      // console.log('id',this.currentMenuId)
      getDept(
        null,
        res => {
          // console.log(res)

          const ArrayDept = [];
          ArrayDept[0] = {};
          ArrayDept[0].deptId = res.obj.deptId;
          ArrayDept[0].deptName = res.obj.deptName;

          if (res.obj.childDeptList && res.obj.childDeptList.length > 0) {
            forData(res.obj.childDeptList); // 去除空值
            ArrayDept[0].childDeptList = res.obj.childDeptList;
          }
          ArrayDept[0].superDeptId = res.obj.superDeptId;
          this.ArrayDept = ArrayDept;
        },
        () => {},
        this.currentMenuId
      );
    },
    // 获取一开始的部门名
    deptChange(id, catalog) {
      // id 是要查找的节点  catalog是存放所有数据的
      const temppath = []; // 定义变量保存当前结果路径
      try {
        function getNodePath(node) {
          temppath.push(node.deptId);
          // 找到符合条件的节点，通过throw终止掉递归
          if (node.deptId == id) {
            throw "GOT IT!";
          }
          if (node.childDeptList && node.childDeptList.length > 0) {
            for (let i = 0; i < node.childDeptList.length; i++) {
              getNodePath(node.childDeptList[i]);
            }
            temppath.pop(); // 当前节点的子节点遍历完依旧没找到，则删除路径中的该节点
          } else {
            temppath.pop(); // 找到叶子节点时，删除路径当中的该叶子节点
          }
        }
        getNodePath(catalog); // catalog 是所有数据
      } catch (e) {
        const result = temppath.join(",");
        return result;
      }
    },
    // 向父组件传选中的部门值
    searchChange() {
      this.handlePanel();
      this.$emit("func", this.curDept, this.deflutKey, this.defaultFg);
    },
    //判断admin
    judgeAdmin() {
      this.isAdmin = judgeSysAdmin(this.logInfo.roleId, this.logInfo.deptId);
    }
  },
  mounted() {
    this.getCurrentDept();
    this.judgeAdmin();
  },
  // 缓存时可以进到此方法
  activated() {
    if (this.refreshDeptFlag) {
      this.getCurrentDept();
    }
  }
};
</script>

<style scoped></style>
